import * as React from 'react';
import * as moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import './MiniSchedule.css';
import 'moment/locale/fr';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { EventService } from '../../../services/EventService';
import { Link } from 'react-router-dom';

/**
 *
 */
export interface Props {
    title: string;
}

export class MiniSchedule extends React.Component {
    props: Props;
    /**
     *
     * date: Date; today: moment.Moment;
     * showMonthPopup: boolean;
     * showYearPopup: boolean; showYearNav: boolean;
     * selectedDay: null; listEvent: any[]}}
     */
    state = {
        dateContext: moment(),
        date: moment().toDate(),
        today: moment(),
        showMonthPopup: false,
        showYearPopup: false,
        showYearNav: false,
        selectedDay: null,
        listEvent: [],
    };
    private event?: ReqType.Event;

    /**
     *
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);

        EventService.getInstance().getEvents().then(
            (resp: ReqType.Event[]) => {
                this.setState({ listEvent: resp });
            }
        ).catch(
            () => alert('Le service marche pas')
        );

    }

    /**
     *
     * @returns {string[]}
     */
    weekdays = () => {
        return moment.weekdays();
    }
    /**
     *
     * @returns {string[]}
     */
    weekdaysShort = () => {
        return moment.weekdaysShort();
    }
    /**
     *
     * @returns {string[]}
     */
    months = () => {
        return moment.months();
    }
    /**
     *
     * @returns {string}
     */
    year = () => {
        return this.state.dateContext.format('Y');
    }
    /**
     *
     * @returns {string}
     */
    month = () => {
        return this.state.dateContext.format('MMM');
    }
    /**
     *
     * @returns {number}
     */
    daysInMonth = () => {
        return this.state.dateContext.daysInMonth();
    }
    /**
     *
     * @returns {number}
     */
    currentDate = () => {
        // alert('currentDate: ' + this.state.dateContext.get('date'));
        return this.state.dateContext.get('date');
    }
    /**
     *
     * @returns {number}
     */
    currentDay = () => {
        let currentDayString = this.state.dateContext.format('D');
        let currentDay: number = +currentDayString;
        return currentDay;
    }
    /**
     *
     * @returns {number}
     */
    firstDayOfMonth = () => {
        let dateContext = this.state.dateContext;
        let firstDayS = moment(dateContext).startOf('month').format('d'); // Day of week 0...1..5...6
        let firstDay: number = +firstDayS;
        return firstDay;
    }

    /**
     * changer de mois
     * @param {string} month
     */
    setMonth = (month: string) => {
        let monthNo: number = this.months().indexOf(month);
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).set('month', monthNo);
        this.setState({ dateContext: dateContext });
    }

    /**
     *
     */
    nextMonth = () => {
        // alert(this.state.date);
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).add(1, 'month');
        this.setState({
            dateContext: dateContext,
        });
    }
    /**
     *
     */
    prevMonth = () => {
        // alert(this.state.date);
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).subtract(1, 'month');
        this.setState({
            dateContext: dateContext,
        });
    }

    /**
     * selectionner pour changer de mois
     * @param {string} data
     */
    onSelectChange = (data: string) => {
        this.setMonth(data);
        // this.props.onMonthChange && this.props.onMonthChange();
    }

    /**
     * selectionner un element dans la liste du mois
     * @param {string[]} data
     * @returns {any}
     * @constructor
     */
    SelectList = (data: string[]) => {
        let popup = data.map((m) => {
            return (
                <div key={m}>
                    <a
                        className="dropdown-item"
                        href="#"
                        onClick={(e) => { this.onSelectChange(m); }}
                    >
                        {m}
                    </a>
                </div>
            );
        });

        return (
            <div className="month-popup">
                {popup}
            </div>
        );
    }

    /**
     * changer de mois
     */
    onChangeMonth = () => {
        this.setState({
            showMonthPopup: !this.state.showMonthPopup
        });
    }

    /**
     * naviguer dans les mois yes
     * @returns {any}
     * @constructor
     */
    MonthNav = () => {
        let Data: string[] = this.months();
        return (
            <span
                className="label-month"
                onClick={this.onChangeMonth}
            >
                {this.month()}
                {
                    this.state.showMonthPopup &&
                    this.SelectList(Data)
                }
            </span>
        );
    }
    /**
     *
     */
    showYearEditor = () => {
        this.setState({ showYearNav: true });
    }
    /**
     *
     * @param {string} year
     */
    setYear = (year: string) => {
        let dateContext = Object.assign({}, this.state.dateContext);
        dateContext = moment(dateContext).set('year', +year);
        this.setState({
            dateContext: dateContext,
        });
    }
    /**
     *
     * @param {React.ChangeEvent<HTMLInputElement>} e
     */
    onYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setYear(e.target.value);
        // this.onYearChange && this.onYearChange(e);
    }

    /**
     * naviguer dans le mois
     * @returns {any}
     * @constructor
     */
    YearNav = () => {
        return (
            this.state.showYearNav ?
                (
                    <input
                        defaultValue={this.year()}
                        className="editor-year"
                        ref={(yearInput) => { yearInput = yearInput; }}
                        onChange={(e) => this.onYearChange(e)}
                        type="number"
                        placeholder="year"
                    />)
                :
                (
                    <span
                        className="label-year"
                        onClick={(e) => { this.showYearEditor(); }}
                    >
                        {this.year()}
                    </span>
                )
        );
    }

    Mousse = () => {
    return (<Link to="/schedule" />);
    }
    /**
     *
     * @param {number} day
     */
    onDayClick = (day: number) => {
        this.state.date.setUTCFullYear(this.state.dateContext.toDate().getUTCFullYear());
        this.state.date.setMonth(this.state.dateContext.toDate().getUTCMonth());
        this.state.date.setDate(day);
        // alert(  this.state.date.toLocaleDateString() );
        this.setState({ date: this.state.date });
    }

    /**
     *
     * @returns {any}
     */
    render() {
        /*const divStyle = {
            cursor: 'pointer'
        };*/

        // affichage des jours en format cours
        /*let weekdays = this.weekdaysShort().map((day) => {
            return (
                <td key={day} className="week-day"><strong>{day}</strong></td>
            );
        });*/

        // affiche du blanc pour les jours qui sont pas dans le mois
        let ind: number = 0; // indice des elements dans le tableau
        let tab = []; // tableau de base
        let tabrow = []; // tableau du mois avec retour a la ligne

        // affichage du blanc pour les jours du mois qui ne sont pas dans la semaine
        for (let i = 0; i < this.firstDayOfMonth(); i++) {
            tab.push((
                <td
                    key={ind}
                    className="emptySlot"
                >
                    {''}
                </td>));
            ind++;
        }

        // ajout des jours de la semaine a la tableau tabRow
        var eventtoday: boolean = false;
        for (let d = 1; d < this.daysInMonth() + 1; d++) { // this.dayInMonth() + 1 pour traité le dernier jour

            this.event = this.state.listEvent.find(
                (e: ReqType.Event) => {
                    return ((e.date_heure_debut.getDate() === d) &&
                        (e.date_heure_debut.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (e.date_heure_debut.getUTCFullYear() === this.state.dateContext.toDate().getUTCFullYear()));
                }
            );

            let currentEvent: ReqType.Event;

            let jour: JSX.Element = <p />;

            let className = () => { return 'day'; };

            jour = <p> {d.toString()} </p>;

            if (this.event !== undefined) {
                eventtoday = true;
                currentEvent = this.event;
                jour = (
                    <p style={{ color: 'white' }}> {d.toString()}
                    </p>
                );

                className = () => {
                    if ((this.state.date.getDate() === d) &&
                        (this.state.date.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (this.state.date.getUTCFullYear() === this.state.dateContext.toDate().getUTCFullYear())) {
                        return 'day event-current';
                    } else if (this.currentDay() === d &&
                        (this.state.dateContext.toDate().getMonth() === this.state.today.toDate().getMonth()) &&
                        (this.state.dateContext.toDate().getUTCFullYear() ===
                            this.state.today.toDate().getUTCFullYear())) {
                        return 'day current-day';
                    } else if ((currentEvent.date_heure_debut.getDate() === d) &&
                        (currentEvent.date_heure_debut.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (currentEvent.date_heure_debut.getUTCFullYear() ===
                            this.state.dateContext.toDate().getUTCFullYear())) {
                        return 'day event-day';
                    } else {
                        return 'day';
                    }
                };
            } else {
                eventtoday = false;
                className = () => {
                    if ((this.state.date.getDate() === d) &&
                        (this.state.date.getMonth() === this.state.dateContext.toDate().getMonth()) &&
                        (this.state.date.getUTCFullYear() === this.state.dateContext.toDate().getUTCFullYear())) {
                        return 'day event-current';
                    } else if (this.currentDay() === d &&
                        (this.state.dateContext.toDate().getMonth() === this.state.today.toDate().getMonth()) &&
                        (this.state.dateContext.toDate().getUTCFullYear() ===
                            this.state.today.toDate().getUTCFullYear())) {
                        return 'day current-day';
                    } else {
                        return 'day';
                    }
                };
                jour = <p> {d.toString()} </p>;
            }

            if ((ind % 7) !== 0) {
                if (eventtoday === true) {
                    tab.push(
                        <td
                            key={ind}
                            className={className()}
                            onClick={this.Mousse}

                        >
                                <strong>
                                    <span>
                                        {jour}
                                    </span>
                                </strong>
                        </td>
                    );

                } else {
                    tab.push(
                        <td
                            key={ind}
                            className={className()}
                        >
                            <strong>
                                <span>
                                    {jour}
                                </span>
                            </strong>
                        </td>
                    );
                }

            } else {
                let inserRow = tab.slice();
                tabrow.push(inserRow);
                tab = [];
                if (eventtoday === true) {
                    tab.push(
                            <td
                                key={ind}
                                className={className()}
                                onClick={this.Mousse}                          
                            >
                                <strong>
                                    <span>
                                        {jour}
                                    </span>
                                </strong>
                            </td>
                    );
                } else {
                    tab.push(
                        <td
                            key={ind}
                            className={className()}  
                        >
                            <strong>
                                <span>
                                    {jour}
                                </span>
                            </strong>
                        </td>
                    );
                }

            }
            if (d === this.daysInMonth()) {
                let insertRow = tab.slice();
                tabrow.push(insertRow);
            }
            ind++;
        }

        // ajout des semaines du mois à la table trElement
        let trElems = tabrow.map((d, i) => {
            return (
                <tr className="tr tr-sm" key={i * 100}>
                    {d}
                </tr>
            );
        });
        return (
            <div>
                <div className="card card-sm">
                    <div className="card-header col-12" >
                        <h6 className="text-white offset-3">
                            <strong>
                                Calendrier
                            </strong>
                        </h6>
                    </div>
                    <div className="card-body">
                        <div className="calendar-container ">
                            <h1 className=" align-content-center">
                                {this.props.title}
                            </h1>
                            <TableChorinitia
                                className={'table-sm'}
                                header={<div />
                                }
                            >
                                <tbody>
                                    {trElems}
                                </tbody>
                            </TableChorinitia>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

// table-striped table-dark


// WEBPACK FOOTER //
// ./src/components/HomePage/internalComponents/MiniSchedule.tsx